import React from 'react';
import { CheckCircle2Icon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const productImage = 'https://cdn.magicpatterns.com/uploads/hgj4ZU5dLU96ft6F38usFD/mockup_oraculo.png';
export function Hero() {
  return <header className="overflow-hidden border-b border-[#DDD7E6] bg-[#F8F7FB] text-[#24212A]" data-id="element-43" data-mp="4m8m0bnacpke">
      <div className="border-b border-[#DCD4E7] bg-[#F1EBFC] px-4 py-2.5 text-center text-[10px] font-bold uppercase tracking-[0.14em] text-[#5B21B6] sm:text-xs" data-id="element-44" data-mp="12a0lxddqa4vo">
        Lanzamiento 2026 · 6 tomos + 6 bonos
      </div>

      <div className="mx-auto flex max-w-4xl flex-col items-center px-5 pb-12 pt-10 text-center sm:px-8 sm:pb-16 sm:pt-14" data-id="element-45" data-mp="sa9r1al99nv2">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45
      }} className="max-w-3xl" data-id="element-46" data-mp="nbosrgpkde99">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#6D28D9]" data-id="element-47" data-mp="3j9u1d0dmvqmc">
            Dra. Karito presenta
          </p>
          <h1 className="mt-3 font-serif text-[3.35rem] font-semibold leading-[0.9] tracking-[-0.055em] text-[#24212A] sm:text-7xl md:text-8xl" data-id="element-48" data-mp="3o5j2h85axfkr">
            El Oráculo
            <span className="block text-[#6D28D9]" data-id="element-49" data-mp="3e84m18jdoqsg">del Terapeuta</span>
            <span className="align-top text-xl sm:text-2xl" data-id="element-50" data-mp="30hhsdush5r38">™</span>
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-xl font-semibold leading-7 text-[#3E3947] sm:text-2xl" data-id="element-51" data-mp="358hlsq2dxr0z">
            Todo lo que necesitás para no volverte a quedar en blanco.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.55,
        delay: 0.1
      }} className="relative mt-7 w-full max-w-[350px] border border-[#DDD7E6] bg-[#FFFDFB] p-2 sm:mt-9 sm:max-w-[430px] sm:p-3" data-id="element-52" data-mp="2viewazuh2v7e">
          <img className="w-full" src={productImage} alt="Colección de tomos y bonos de El Oráculo del Terapeuta" data-id="element-53" data-mp="nb1o3ec0ka16" />
          <p className="absolute bottom-4 left-1/2 -translate-x-1/2 whitespace-nowrap border border-[#CDBCEB] bg-[#F5F0FC] px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.1em] text-[#5B21B6] sm:text-xs" data-id="element-54" data-mp="dd5cymj2tf32">
            +445 páginas prácticas
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.2
      }} className="mt-7 w-full max-w-md" data-id="element-55" data-mp="15zq1lf863d2x">
          <p className="mx-auto max-w-lg text-sm leading-6 text-[#5E5968]" data-id="element-56" data-mp="3hrd7mqiwb1xs">
            Guiones de rescate, protocolos clínicos y herramientas de
            auto-supervisión para actuar con calma cuando más importa.
          </p>
          <div className="mt-5" data-id="element-57" data-mp="21a4t5ua36g5g">
            <CTAButton ariaLabel="Comprar El Oráculo del Terapeuta ahora" data-id="element-58" data-mp="21bfxpwbcvrxm">
              Quiero mi Oráculo ahora
            </CTAButton>
          </div>
          <div className="mt-6 grid grid-cols-3 gap-1 border-t border-[#DDD7E6] pt-5 text-[10px] font-semibold leading-4 text-[#514B5A] sm:text-[11px]" data-id="element-59" data-mp="2b196yqo0zuyp">
            <span className="flex flex-col items-center gap-1" data-id="element-60" data-mp="2fzj436tb95my">
              <ZapIcon className="h-4 w-4 text-[#6D28D9]" aria-hidden="true" data-id="element-61" data-mp="2kxucdd3yj832" />
              Acceso en 5 min
            </span>
            <span className="flex flex-col items-center gap-1" data-id="element-62" data-mp="2p1a6a1on6uc2">
              <ShieldCheckIcon className="h-4 w-4 text-[#6D28D9]" aria-hidden="true" data-id="element-63" data-mp="2tztvcayj8m8n" />
              Garantía 7 días
            </span>
            <span className="flex flex-col items-center gap-1" data-id="element-64" data-mp="zlausdxjwst9">
              <CheckCircle2Icon className="h-4 w-4 text-[#6D28D9]" aria-hidden="true" data-id="element-65" data-mp="znn7ocogcczg" />
              100% PDF
            </span>
          </div>
        </motion.div>
      </div>
    </header>;
}